import React, { useEffect, useState } from 'react';

interface RedirectCountdownProps {
  /** Number of seconds to count down from */
  seconds: number;
  /** Message to display with countdown */
  message?: string;
}

/**
 * RedirectCountdown Component
 *
 * Displays a countdown timer before auto-redirect.
 * Provides visual feedback to users that a redirect is about to occur.
 *
 * @component
 * @example
 * ```tsx
 * <RedirectCountdown seconds={3} message="Redirecting to runner provisioning in" />
 * ```
 */
const RedirectCountdown: React.FC<RedirectCountdownProps> = ({ seconds, message = 'Redirecting in' }) => {
  const [countdown, setCountdown] = useState(seconds);

  useEffect(() => {
    if (countdown <= 0) return;

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  return (
    <p className="mt-2 text-sm text-gray-600">
      {message} <span className="font-medium text-dataops-primary-blue">{countdown}</span>{' '}
      {countdown === 1 ? 'second' : 'seconds'}...
    </p>
  );
};

export default RedirectCountdown;
